import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const TankIcon = ({ width = 16, height = 22, color }: { width?: number; height?: number; color?: string }) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3008 0C13.7365 0 15.7118 1.97448 15.7119 4.41016V14.4443C15.7118 15.5317 15.3165 16.5261 14.6641 17.2949V20.9531C14.6641 21.5315 14.1955 22.0008 13.6172 22.001C13.0387 22.001 12.5693 21.5316 12.5693 20.9531V18.668C12.1676 18.7884 11.7417 18.8545 11.3008 18.8545H4.41016C3.96916 18.8545 3.54338 18.7884 3.1416 18.668V20.957C3.14153 21.5354 2.67309 22.0038 2.09473 22.0039C1.51627 22.0039 1.04694 21.5355 1.04688 20.957V17.2949C0.394442 16.5261 0.000108366 15.5317 0 14.4443V4.41016C0.000102059 1.97448 1.97445 0 4.41016 0H11.3008Z"
        fill={currentColor}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default TankIcon;
